export enum ScheduledActionTypes {
  PRICE_CHANGE = "price_change",
  INTERVAL_CHANGE = "interval_change",
  MANUAL_RENEW = "recurring_invoice_change",
  CANCEL_IMMEDIATELY = "contract_product_cancel_immediately",
  CANCEL_END_OF_BILLING_TERM = "contract_product_cancel_end_of_billing_term"
}

export enum ScheduledActionPriceChangeType {
  FIXED = "fixed",
  PERCENTAGE_ADD = "percentage_add",
  PERCENTAGE_REMOVE = "percentage_remove"
}

export enum ScheduledActionPriceChangeDirection {
  UP = "up",
  DOWN = "down"
}

export enum ScheduledActionStatusTypes {
  STATUS_CANCELLED = "contract_product_scheduled_action_cancelled",
  STATUS_EXECUTED = "contract_product_scheduled_action_executed",
  STATUS_OVERRIDDEN = "contract_product_scheduled_action_overridden",
  STATUS_REVERTED = "contract_product_scheduled_action_reverted",
  STATUS_SCHEDULED = "contract_product_scheduled_action_scheduled"
}
